import React from "react";
import AntdAlert from 'antd/lib/alert';

export default (props) => <AntdAlert {...props} />;




// WEBPACK FOOTER //
// ./src/components/alert/index.tsx